import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../utils/constants';

const postFeedback = (requestBody) =>
  axios.post(`${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${endpoints.shipping.feedback}`, requestBody);
export default postFeedback;
